export default __webpack_public_path__ + "static/media/exclamation-mark-in-a-circle-svgrepo-com.50dfe8fa.svg";